export const MATH_QUEST_2_QUESTIONS = [
  {
    id: 'mq2_1',
    text: '39 + 54 = ___',
    category: 'Math Quest 2',
    grade_level: '1C-2A',
    correct_answer: '93',
  },
  {
    id: 'mq2_2',
    text: '17 + __ = 53',
    category: 'Math Quest 2',
    grade_level: '1C-2A',
    correct_answer: '36',
  },
  {
    id: 'mq2_3',
    text: '8 x 6 =',
    category: 'Math Quest 2',
    grade_level: '1C-2A',
    correct_answer: '48',
  },
  {
    id: 'mq2_4',
    text: '72 ÷ 8 = ___',
    category: 'Math Quest 2',
    grade_level: '1C-2A',
    correct_answer: '9',
  },
  {
    id: 'mq2_5',
    text: '45 - 28 = ___',
    category: 'Math Quest 2',
    grade_level: '1C-2A',
    correct_answer: '17',
  },
];
